import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { WebRequestService } from 'src/app/services/web-request.service';
import { BrokerCreateDialogComponent } from '../broker-create-dialog/broker-create-dialog.component';

@Component({
  selector: 'app-broker-management',
  templateUrl: './broker-management.component.html',
  styleUrls: ['./broker-management.component.scss']
})
export class BrokerManagementComponent implements OnInit {

  LoaderComponent: any;
  brokerList: any[] = [];
  gridType: any = 'branch';
  matchedHeaders: any[];
  headers: string[];
  responseMessage: any;
  @ViewChild('successModal') successModal: any;
  constructor(
    public dialog: MatDialog,
    public service: WebRequestService
  ) { }

  ngOnInit(): void {
    this.loadBrokerList();
  }

  loadBrokerList() {
    this.brokerList = [];
    this.LoaderComponent = LoaderComponent;
    this.service.getAllBrokers().then((res) => {
      if(res['statusCode'] === 200) {
        this.LoaderComponent = '';
        this.brokerList = res['result']
        this.prepareHeaders();
      } else {
        this.LoaderComponent = '';
        this.responseMessage = res['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 3000);
      }
    })
  }

  prepareHeaders() {
    this.matchedHeaders = [
      { title: 'Sno', value: 'SNO' },
      { title: 'Name', value: 'name' },
      { title: 'Email', value: 'email' },
      { title: 'Mobile Number', value: 'mobileNumber' },
      { title: 'Registration Commission', value: 'registrationCommission' },
      { title: 'Settlement Commission', value: 'settlementCommission' },
      { title: 'Edit', value: 'edit' },
      { title: 'Delete', value: 'delete' },
      
    ]

    this.headers = ['SNO', 'name', 'email', 'mobileNumber', 'registrationCommission', 'settlementCommission', 'edit', 'delete']
  }

  createBroker() {
    const dialogRef = this.dialog.open(BrokerCreateDialogComponent, {
      width: '1000px',
    })

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.loadBrokerList();
      }
    })
  }

  reLoadBrokerList(event) {
    if(event) {
      this.loadBrokerList();
    }
  }

}
